import { render, staticRenderFns } from "./AddDispatchOrder.vue?vue&type=template&id=f1384dc6&scoped=true"
import script from "./AddDispatchOrder.vue?vue&type=script&lang=js"
export * from "./AddDispatchOrder.vue?vue&type=script&lang=js"
import style0 from "./AddDispatchOrder.vue?vue&type=style&index=0&id=f1384dc6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1384dc6",
  null
  
)

export default component.exports